import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout'
import { Injectable, DestroyRef, inject, signal } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

@Injectable({ providedIn: 'root' })
export class LayoutService {
  private breakpointObserver = inject(BreakpointObserver)
  private destroyRef = inject(DestroyRef)

  isMobile = signal(false)

  constructor() {
    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        this.isMobile.set(result.matches)
      })
  }
}
